import React from "react";
import { Card, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";

const CardResume = (props) => {
  const { show, handleEdit, children, title, icon } = props;

  return (
    <Card
      className="mt-2 mb-2"
      hidden={!show}
      style={{ backgroundColor: "#e9ecef" }}
    >
      <Card.Body>
        <h6>
          <FontAwesomeIcon icon={icon} className="me-2 text-success" />
          {title}
        </h6>
        <Card.Text>
          {children}
          <span className="float-end">
            <Button variant="link" className="mb-0 p-0 " onClick={handleEdit}>
              <FontAwesomeIcon icon={faEdit} /> editar
            </Button>
          </span>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default CardResume;
